module.exports = __webpack_public_path__ + "static/media/tire_unselected.7697295f.svg";